(() => {
  const initialise = (root) => {
    if (root.dataset.bespokeReady === 'true') return;
    root.dataset.bespokeReady = 'true';

    const openers = new Map();

    root.querySelectorAll('[data-bespoke-open]').forEach((button) => {
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog) return;

      let lastFocused = null;
      const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const closeDialog = () => {
        dialog.hidden = true;
        document.body.style.removeProperty('overflow');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      };
      const openDialog = ({ focusTitle = false, returnFocus = null } = {}) => {
        lastFocused = returnFocus || document.activeElement;
        dialog.hidden = false;
        document.body.style.overflow = 'hidden';
        const focusTarget = focusTitle
          ? dialog.querySelector('[aria-labelledby] h2, h2[tabindex="-1"]')
          : dialog.querySelector('[data-bespoke-close]');
        const focusSafely = () => {
          if (!dialog.hidden && focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus({ preventScroll: true });
          }
        };
        focusSafely();
        if (focusTitle) {
          window.setTimeout(focusSafely, 800);
          window.setTimeout(focusSafely, 1800);
        }
      };

      openers.set(button, openDialog);
      button.addEventListener('click', () => openDialog());
      dialog.querySelector('[data-bespoke-close]')?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDialog();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });

    const openFromHash = () => {
      const match = window.location.hash.match(/^#look-(\d{2})$/);
      if (!match) return;

      const look = document.getElementById(`look-${match[1]}`);
      if (!look || !root.contains(look)) return;

      const button = look.querySelector('[data-bespoke-open]');
      const openDialog = openers.get(button);
      if (!button || !openDialog) return;

      const header = document.querySelector('.m-header__wrapper, .m-header');
      const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 72);
      look.style.scrollMarginTop = `${headerHeight + 24}px`;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      look.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      window.setTimeout(
        () => openDialog({ focusTitle: true, returnFocus: button }),
        reduceMotion ? 0 : 450
      );
    };

    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  };

  document.querySelectorAll('[data-bespoke-portfolio]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-bespoke-portfolio]').forEach(initialise);
  });
})();

